import { render, staticRenderFns } from "./ReceiptFilter.vue?vue&type=template&id=f961c0b4"
import script from "./ReceiptFilter.vue?vue&type=script&lang=ts"
export * from "./ReceiptFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports